var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { createContainer } from 'unstated-next';
import { saveTemplate, getCurrentUser, getTemplate } from '../../../../../api';
import t from '../../../../../lib/translate';
var PARSE_ERROR = 'template_parse_failed';
var useEditTemplate = function () {
    var _a = useParams(), productKey = _a.productKey, templateKey = _a.templateKey, templateVersionParam = _a.templateVersion;
    var templateVersion = templateVersionParam.replace('_', '.');
    var _b = useState(), template = _b[0], setTemplate = _b[1];
    var _c = useState(false), isStaffUser = _c[0], setIsStaffUser = _c[1];
    var _d = useState(), content = _d[0], setContent = _d[1];
    var _e = useState(), subject = _e[0], setSubject = _e[1];
    var _f = useState({ label: 'MINOR', value: 'MINOR' }), changeType = _f[0], setChangeType = _f[1];
    var _g = useState([]), sendWindows = _g[0], setSendWindows = _g[1];
    var _h = useState(true), active = _h[0], setActive = _h[1];
    var navigate = useNavigate();
    useEffect(function () {
        getCurrentUser().then(function (res) { return setIsStaffUser(res.isDiUser); });
    }, []);
    useEffect(function () {
        getTemplate(productKey, templateKey, templateVersion)
            .then(function (res) { return setTemplate(res); });
    }, [productKey, templateKey, templateVersion]);
    useEffect(function () {
        if (template) {
            setContent(template.content);
            if (template.channel === 'EMAIL' && 'subject' in template.content) {
                setSubject(template.content.subject);
            }
            setSendWindows(template.sendWindows);
            setActive(template.active);
        }
    }, [template]);
    var saveTemplateFunc = function (e) {
        e.preventDefault();
        if (!(template === null || template === void 0 ? void 0 : template.version) || !content)
            return false;
        if ('subject' in content) {
            if (subject != null) {
                content.subject = subject;
            }
        }
        var templateToSave = template.channel === 'EMAIL' && 'subject' in content
            ? {
                content: content,
                editedVersion: template.version,
                changeType: changeType.value,
                active: active,
                sendWindows: sendWindows,
                channel: 'EMAIL'
            }
            : {
                content: content,
                editedVersion: template.version,
                changeType: changeType.value,
                active: active,
                sendWindows: sendWindows,
                channel: 'SMS'
            };
        saveTemplate(productKey, templateKey, templateToSave)
            .then(function (res) {
            toast.success(t('templates.updated', res.key, res.version));
            navigate("/admin/templates/".concat(res.ownerparty.key, "/").concat(res.key, "/").concat(res.version.replace('.', '_')));
            setTemplate(res);
        })
            .catch(function (error) { return __awaiter(void 0, void 0, void 0, function () {
            var body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, error.json()];
                    case 1:
                        body = _a.sent();
                        if (body.errors.length > 0) {
                            body.errors.forEach(function (e) {
                                var generalMessage = t('templates.failed.to.update');
                                var specificError = e.errorKey === PARSE_ERROR
                                    ? e.errorMessage
                                    : t("templates.errors.".concat(e.errorKey));
                                toast.error("".concat(generalMessage, ": ").concat(specificError));
                            });
                        }
                        else {
                            toast.error(t('templates.failed.to.update'));
                        }
                        return [2 /*return*/];
                }
            });
        }); });
    };
    return {
        template: template,
        saveTemplateFunc: saveTemplateFunc,
        setChangeType: setChangeType,
        setContent: setContent,
        content: content,
        setSubject: setSubject,
        subject: subject,
        isStaffUser: isStaffUser,
        sendWindows: sendWindows,
        setSendWindows: setSendWindows,
        active: active,
        setActive: setActive
    };
};
var EditTemplates = createContainer(useEditTemplate);
export default EditTemplates;
